// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-17Tsj";
var _3 = "content-61Kxj";
var _4 = "message-dLVOz";
export { _1 as "__esModule", _2 as "root", _3 as "content", _4 as "message" }
export default { "__esModule": _1, "root": _2, "content": _3, "message": _4 }
